'use strict';

export const DATE_FORMAT = 'dd.MM.yyyy';
export const DATE_TIME_FORMAT = 'dd.MM.yyyy H:mm';
export const DATE_TIME_FORMAT_WITH_SECONDS = 'dd.MM.yyyy H:mm:ss';

export const MOMENT_DATE_FORMAT = 'DD.MM.YYYY';
